const games_es = require('./games.json')
export default games_es
